<template>
  <Page />
</template>
<script>
import Page from '../components/CommonPage.vue';
export default {
  name: 'BusinessPurchaseReturnInform',
  components: {
    Page,
  },
  data() {
    return {};
  },
};
</script>
